export default {
	'weight-and-quality-certificates': 'شهادات الصنف والوزن',
    'weight-and-quality-certificate': 'شهادة الصنف والوزن',
    'add-a-weight-and-quality-certificate': 'إضافة شهادة صنف ووزن'
}